export default "__VITE_ASSET__CndiYDmF__"